import { render } from "./ReservationCard.vue?vue&type=template&id=639a056c&scoped=true"
import script from "./ReservationCard.vue?vue&type=script&lang=js"
export * from "./ReservationCard.vue?vue&type=script&lang=js"

import "./ReservationCard.vue?vue&type=style&index=0&id=639a056c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639a056c"]])

export default __exports__